import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AddTypeFiles, EditTypeFiles } from './type-files.interface';

@Injectable({
    providedIn: 'root',
})
export class TypeFilesService {
    private token!: string;
    private basePath = environment.interop.basePath;

    private listUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.documentTypes.list;

    public listDTUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.documentTypes.listDT;

    private findURL =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.documentTypes.find;

    private storeURL =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.documentTypes.store;

    private updateUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.documentTypes.update;

    private deleteUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.documentTypes.delete;

    private listActiveUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.documentTypes
            .listActive;

    private listPublicUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.documentTypes
            .listPublic;

    private changeStatusActiveUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.documentTypes
            .active;

    private changeStatusPublicUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.documentTypes
            .public;

    private httpOptions: any;

    constructor(private http: HttpClient) { }

    getListDT() {
        return this.http.get(this.listDTUrl, this.httpOptions);
    }

    findEntry(id: number) {
        return this.http.post(this.findURL + id, this.httpOptions);
    }

    storeEntry(payload: AddTypeFiles) {
        return this.http.post(this.storeURL, payload, this.httpOptions);
    }

    updateEntry(payload: EditTypeFiles) {
        return this.http.put(this.updateUrl, payload, this.httpOptions);
    }

    deleteEntry(id: number) {
        return this.http.delete(this.deleteUrl + id, this.httpOptions);
    }

    getListActive() {
        return this.http.get(this.listActiveUrl, this.httpOptions);
    }

    getListPublic() {
        return this.http.get(this.listPublicUrl, this.httpOptions);
    }

    changeStatusActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusPublic(id: number) {
        return this.http.put(this.changeStatusPublicUrl + id, {}, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
